<template>
    <div
        class="uik-trend"
        :class="[
            `uik-trend--${type}`,
            `uik-trend--${direction}`
        ]"
    >
        <div class="uik-trend__arrow"/>
        <span v-if="content" class="uik-trend__content">{{ content }}</span>
    </div>
</template>

<script>
export default {
    name: "UikTrend",
    props: {
        /**
         * Trend type - defines color
         */
        type: {
            type: String,
            default: "good",
            validator (value) {
                return [
                    "good",
                    "bad"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Direction the arrow is pointing at
         */
        direction: {
            type: String,
            default: "up",
            validator (value) {
                return [
                    "up",
                    "down"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Trend value
         */
        content: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss">
.uik-trend {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  .uik-trend__arrow {
    margin-right: 4px;
    width: 0;
    height: 0;
    border-left: solid 5px transparent !important;
    border-right: solid 5px transparent !important;
  }

  .uik-trend__content {
    color: $textBase;
    font-size: 13px;
    font-weight: 600;
  }

  &--up {
    .uik-trend__arrow {
      transform: translateY(1px);
      border-bottom: solid 6px transparent;
    }
  }

  &--down {
    .uik-trend__arrow {
      border-top: solid 6px transparent;
    }
  }

  &--good {
    .uik-trend__arrow {
      border-color: $success;
    }

    .uik-trend__content {
      color: $success;
    }
  }

  &--bad {
    .uik-trend__arrow {
      border-color: $error;
    }

    .uik-trend__content {
      color: $error;
    }
  }
}
</style>
